import React from "react";
import "../styles/styles.css";
import { formatDate, timeString } from "../../../utils/formatDate";

// Compact single-line "registered by" summary for the shell header —
// replaces the old stacked 3-line block (name / phone / group) that used to
// sit above the form. Also carries the registration/last-change timestamps
// when given, as further " · "-joined segments on the same line.
// createdLabel names the createdAt timestamp: a person's "Datum prijave"
// (default) vs a user's "Datum registracije".
const RegisteredByLine = ({ korisnik, createdAt, updatedAt, createdLabel, t }) => {
  const whoParts = korisnik
    ? [
        `${korisnik.ime || ""} ${korisnik.prezime || ""}`.trim(),
        korisnik.broj_telefona || korisnik.telefon,
        korisnik.grupa?.skracenica && korisnik.grupa?.naziv
          ? `${korisnik.grupa.skracenica} - ${korisnik.grupa.naziv}`
          : korisnik.grupa?.naziv,
      ].filter(Boolean)
    : [];

  const formatDateTime = (iso) =>
    iso ? `${formatDate(iso)} ${timeString(iso)}` : null;

  if (!whoParts.length && !createdAt && !updatedAt) return null;

  return (
    <p className="font-14 inria-sans-400 edit-modal-shell-registered-by">
      {whoParts.length > 0 && (
        <>
          <span className="inria-sans-700">
            {t?.("REGISTERED_BY") || "Registrovao"}:
          </span>{" "}
          {whoParts.join(" · ")}
        </>
      )}
      {createdAt && (
        <>
          {whoParts.length > 0 && "  ·  "}
          <span className="inria-sans-700">
            {createdLabel || t?.("SUBMISSION_DATE") || "Datum prijave"}:
          </span>{" "}
          {formatDateTime(createdAt)}
        </>
      )}
      {updatedAt && (
        <>
          {(whoParts.length > 0 || createdAt) && "  ·  "}
          <span className="inria-sans-700">
            {t?.("LAST_CHANGED") || "Poslednja izmena"}:
          </span>{" "}
          {formatDateTime(updatedAt)}
        </>
      )}
    </p>
  );
};

export default RegisteredByLine;
